//@ts-nocheck
import "./app.css"
import { ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import Router from "./router";
import { BrowserRouter } from "react-router-dom";
import { QueryClient, QueryClientProvider } from "@tanstack/react-query";
import { HotkeysProvider } from 'react-hotkeys-hook';

export const queryClient = new QueryClient();

export default function Root(props) {
  return (
    <>
      <QueryClientProvider client={queryClient}>
        <BrowserRouter>
          <HotkeysProvider>
            <Router />
          </HotkeysProvider>
        </BrowserRouter>
        <ToastContainer autoClose={500} draggablePercent={30} />
      </QueryClientProvider>
    </>
  );
}
